// Filename normalization and CSV download helpers used across exports

// Normalize a portfolio name to a slug: lowercase, underscores, alnum only, max 50 chars
export const normalizePortfolioSlug = (name) => {
  const raw = (name || 'portfolio').toString();
  const slug = raw.trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]+/g, '').slice(0, 50);
  return slug || 'portfolio';
};

// Build compact timestamp like 20250929_142533
export const buildTimestamp = (d = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
};

// Build standardized export filename
// kind: transactions | exit_levels | groups | locations
export const buildExportFilename = (portfolioName, kind, ext = 'csv') => {
  const slug = normalizePortfolioSlug(portfolioName);
  const stamp = buildTimestamp();
  return `${slug}_${kind}_${stamp}.${ext}`;
};

// Download a CSV string with a standardized filename
export const downloadCSV = (csvString, portfolioName, kind) => {
  const blob = new Blob([csvString || ''], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = buildExportFilename(portfolioName, kind, 'csv');
  link.click();
  URL.revokeObjectURL(url);
};


